import React from 'react';
import {
  Box,
  Paper,
  Typography,
} from '@mui/material';
import { WhatsApp as WhatsAppIcon } from '@mui/icons-material';

const WhatsAppAutomation: React.FC = () => {
  return (
    <Box>
      <Box sx={{ mb: 3, display: 'flex', alignItems: 'center', gap: 2 }}>
        <WhatsAppIcon sx={{ fontSize: 32, color: '#25D366' }} />
        <Typography variant="h4" sx={{ fontWeight: 700 }}>
          Automação WhatsApp
        </Typography>
      </Box>

      <Paper sx={{ p: 3 }}>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          Em desenvolvimento...
        </Typography>
      </Paper>
    </Box>
  );
};

export default WhatsAppAutomation;

